import { render, staticRenderFns } from "./CourseContainer.vue?vue&type=template&id=c225d1c0&scoped=true&"
import script from "./CourseContainer.vue?vue&type=script&lang=js&"
export * from "./CourseContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c225d1c0",
  null
  
)

export default component.exports